import { render, staticRenderFns } from "./ContractedWorksAcceptanceInfo.vue?vue&type=template&id=0c23a2f6&"
import script from "./ContractedWorksAcceptanceInfo.vue?vue&type=script&lang=js&"
export * from "./ContractedWorksAcceptanceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports